import React from 'react';
import PropTypes from 'prop-types';
import ScrollDown from './ScrollDown';
import BackgroundVideo from 'epic-react-common/src/components/BackgroundVideo';

export default class RecallSection extends React.PureComponent {
    static propTypes = {
        active: PropTypes.bool,
        item: PropTypes.object,
        initLoad: PropTypes.bool,
        mobile: PropTypes.bool,
        tablet: PropTypes.bool,
        dirty: PropTypes.bool
    };

    render() {
        let contentStyle = 'content';
        if (!this.props.initLoad && this.props.active) {
            contentStyle = 'content notLoaded';
        } else if (this.props.initLoad && this.props.active) {
            contentStyle = 'content active';
        }

        const item = this.props.item || {};
        const background = item.background || [];
        const buttonsArray = [];
        for (const linkItem of item.ctaLink) {
            const {textOne, link} = linkItem;
            const key = `btn-${textOne}`;
            buttonsArray.push(
                <a
                    key={key}
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={textOne}
                    className="btn cta-btn">
                    <span>{textOne}</span>
                </a>
            );
        }

        //const ctaString = item.ctaLink ? item.ctaLink.ctaString : '';

        return (
            <div id="recallSection" className="section">
                <BackgroundVideo
                    background={background}
                    play={this.props.active}
                    fixed={false}
                    forcePause={false}
                    noOverlay={false}
                    playPauseOverlay={false}
                    mute={true}
                    loop={true}
                    backgroundVideo={true}
                    mobile={this.props.mobile}
                    tablet={this.props.tablet}
                    dirty={this.props.dirty}
                    enableRatioHelper={true} />
                <div className={contentStyle}>
                    <i className="icon-rr_logo" />
                    <span
                        dangerouslySetInnerHTML={{__html: item.description}} />
                    <div className="btn-container">{buttonsArray}</div>
                    {item.powerText ? (
                        <h4 className="recallText">{item.powerText}</h4>
                    ) : null}
                </div>
                <ScrollDown
                    initLoad={this.props.initLoad}
                    hide={!this.props.active} />
            </div>
        );
    }
}
